import React from 'react'

export default function IconeCarrinho({ ...rest }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M14 14H10.5C9.67157 14 9 14.6716 9 15.5C9 16.3284 9.67157 17 10.5 17H14M14 14L16.5 28H38.5L42 17H14ZM14 14L12 10H6"
        stroke="#3D3D3D"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="18" cy="36" r="3" stroke="#3D3D3D" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="36" cy="36" r="3" stroke="#3D3D3D" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
